module.exports = __webpack_public_path__ + "img/logo-iris-global.14f0ed71.svg";